import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';


function Ms_AdmissionELe() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);

    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Admissionleft activeIndex={1} />
                    </Col>

                    <Col md={8} className='c-right'>
                        <div className="c-heading">
                            <h3>M.S. (Research)</h3> <br />
                        </div>
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col  xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Dates
                                </Button>
                            </Col>

                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                    Guidelines
                                </Button>
                            </Col>

                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}>
                                    Categories
                                </Button>
                            </Col>

                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}>
                                    Areas
                                </Button>
                            </Col>

                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setEligiblityOpen)}
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}>
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setFinancialOpen)}
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}>
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}>
                                    Selection
                                </Button>
                            </Col>
                            {/* Documents */}
                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setDocumentsOpen)}
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}>
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}>
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col   xs={6} sm={4} md={2} lg={2}  className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setApplyonlineOpen)}
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}>
                                    Apply Online
                                </Button>
                            </Col>



                        </Row>


                        {/*dates */}
                        <div>
                            {datesOpen && <Fade in={datesOpen}>
                                <div>
                                    {/* <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" />
                                    <a className='text-maroon' href="https://files.iittp.ac.in/pdfs/admissions/2024/MS_PhD_July_2024_Flyer.pdf" target="_blank;"><b> M.S.(R) Admissions for July-2024 Brochure - Click here</b></a> */}


                                    <Table bordered responsive className='mt-3'>
                                        <thead>
                                            <tr>
                                                <th colSpan="2" className="text-center">
                                                    <h4 className="text-primary">Important Dates</h4>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Opening date and time for online application</td>
                                                <td><b>Wednesday, March 13, 2024 at 10 AM</b></td>
                                            </tr>
                                            <tr>
                                                <td>Closing date and time for online application</td>
                                                <td><b>Wednesday, April 10, 2024 upto 5 PM</b></td>
                                            </tr>
                                            <tr>
                                                <td>Written Test / Interview</td>
                                                <td><b>	01-May-2024 to 24-May-2024</b></td>
                                            </tr>
                                            <tr>
                                                <td>Announcement of Results</td>
                                                <td><b>Within one week from the completion of Interview</b></td>
                                            </tr>
                                            <tr>
                                                <td>Reporting to Campus</td>
                                                <td><b>Monday, July 22, 2024</b></td>
                                            </tr>
                                            <tr>
                                                <td>Date of Orientation Program</td>
                                                <td><b>Thursday, July 25, 2024</b></td>
                                            </tr>

                                            <tr>
                                                <td>Commencement of classes </td>
                                                <td><b>Thursday, August 1, 2024</b></td>
                                            </tr>


                                        </tbody>
                                    </Table>

                                    <b>Please write to <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link>  for any questions or queries regarding admission related matters. </b>
                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Guidelines*/}

                        <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='c-lineheight2dot5'>

                                    <h4 className="mb-3">Important Guidelines</h4>
                                    <ol style={{ textAlign: 'justify', fontSize: '12pt' }}>
                                        <li>
                                            1) The link to the online application form is available in the Apply Online tab. After filling out the form, please take a print and keep it for your record.
                                        </li>
                                        <li>
                                            2) The application fee is as follows:
                                            <ul className='myulcustarrow'>
                                                <li>
                                                    GEN/EWS/OBC-NCL Male candidates: Rs.400/-
                                                </li>
                                                <li>
                                                    GEN/EWS/OBC-NCL Female candidates: Rs.200/-
                                                </li>
                                                <li>
                                                    SC/ST and PwD candidates: Rs.200/-
                                                </li>
                                            </ul>
                                            <p style={{ color: '#2009df' }}>The application fee is non-refundable. Please ensure to save the payment reference number.</p>
                                        </li>
                                        <li>
                                           3) A candidate can apply to more than one department; however, the maximum number of departments to which he/she can apply will be three.
                                        </li>
                                        <li>
                                            4) Candidates called for the written test/interview must produce a copy of the application submitted online along with originals and photocopies of the relevant certificates.
                                        </li>
                                        <li>
                                            5) Reservation/concession/relaxations for EWS/OBC-NCL/SC/ST/PwD and Kashmiri- Migrants (KM), including Kashmiri Pandits/Kashmiri Hindu Families: As per the Government of India rules. A copy of a valid OBC-NCL/ST/SC/EWS/PwD certificate must be uploaded during the ONLINE application and must be submitted at the time of admission.
                                        </li>
                                        <li>
                                            6) A Statement of Purpose (SoP) must be uploaded along with the online application. The guidelines for preparing the SoP are available at this <a href="https://files.iittp.ac.in/pdfs/admissions/2023/docx/1.docx" target="_blank" rel="noopener noreferrer">Link</a>.
                                        </li>
                                        <li>
                                           7) At the time of physical reporting to the Institute, candidates must submit self-attested copies of the relevant certificates as specified in the Documents tab, failing which admission will stand cancelled.
                                        </li>
                                        <li>
                                           8) Please make all files ready with the following format and size before going to file upload:
                                            <ul className='myulcustarrow'>
                                                <li> Passport size Photo (jpg, jpeg, png), size &lt;=500 KB</li>
                                                <li> Signature (format jpg, jpeg, png) size &lt;= 200 KB</li>
                                                <li> 10th Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> 12th / Diploma / Equivalent Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> Qualifying UG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> Consolidated UG mark sheet (pdf) size &lt;=1024 KB</li>
                                                <li> Qualifying PG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                <li> Consolidated PG mark sheet (pdf) size &lt;=1024 KB</li>
                                                <li> Community Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                <li> PwD Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                <li> Applicable National Level Exams/GATE (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                                <li> SoP/Research Proposal, (pdf) size &lt;=1024 KB</li>
                                                <li> First page of publication, if applicable (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                            </ul>
                                            <p><b>Additional documents for external/part-time/internal category candidates</b></p>
                                            <ul className='myulcustarrow'>
                                                <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                <li> No-Objection Certificate or Undertaking as given, format available at this <a href="https://files.iittp.ac.in/pdfs/admissions/2023/docx/2.docx" target="_blank" rel="noopener noreferrer">link</a>, (pdf) size &lt;=1024 KB</li>
                                            </ul>
                                        </li>
                                        <li>
                                            9) Please visit the institute’s website regularly for important announcements and results.
                                        </li>
                                        <li>
                                            10) In case of any queries, please write to{' '}
                                            <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link> or call 0877-250 3531 (9.00 AM to 5.30 PM on all working days).
                                        </li>
                                    </ol>

                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Categoies*/}

                        <div>
                            {categoryOpen && <Fade in={categoryOpen}>
                                <div className='c-lineheight2dot5'>

                                    <h5 className="mb-3">M.S.(Research) admissions are made under various modes of HTRA (Half Time Research Assistantship) and Non-HTRA categories as mentioned below:</h5>

                                    <h5 className='me-3 mt-3'>HTRA Category: </h5>
                                    <ul className="">
                                        <li>
                                            <b>  1. Regular (Full-time scholars): </b> The research scholars selected under regular registration will be eligible for assistantship through various schemes (please see Financial Assistance)
                                        </li>
                                    </ul>
                                    <h5 className='me-3 mt-3'>Non-HTRA Category:</h5>
                                    <ul className="">
                                        <li>
                                            <b>  1. External: </b>
                                            <ul className='myulcustarrow'>


                                                <li> The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST or by IIT Tirupati.</li>
                                                <li> Research scholars admitted under this category will normally carry out part or all of their research in the parent organization under supervision of a faculty from IIT Tirupati and a co-supervisor employed in their parent organization.</li>

                                                <li> The following documents are required along with the application
                                                    <ul className='myulcustarrow'>
                                                        <li>Proof of employment (Identity Card or latest salary statement)</li>
                                                        <li>No-Objection Certificate or Undertaking (format available at this <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/3.docx" target="_blank;" className='c-link'>Link</Link>)</li>
                                                    </ul>

                                                </li>

                                                <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow'>
                                                        <li>Certificate of Support from the Employer: <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/4.docx" target="_blank;" className='c-link'>Link</Link></li>
                                                        <li>Relieving Certificate from the Employer: <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/5.docx" target="_blank;" className='c-link'>Link</Link></li>
                                                    </ul>
                                                </li>

                                            </ul>
                                        </li>
                                    </ul>


                                    <ul>
                                        <li>
                                            <b>  2. Part-Time: </b>

                                            <ul className='myulcustarrow'>
                                                <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                                <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>

                                                <p>Note: The minimum residential requirement for the M.S. research scholars under External registration and M.S. research scholars under Part-time registration is one semester.</p>
                                                
                                                <li> The following documents are required at the time of application
                                                    <ul className='myulcustarrow'>
                                                        <li>Proof of employment (Identity Card or latest salary statement)</li>
                                                        <li>No-Objection Certificate or Undertaking (format available at this <a className='c-link'  href="https://files.iittp.ac.in/pdfs/admissions/2023/docx/undertaking.docx" target="_blank;">link</a>)</li>
                                                    </ul>
                                                </li>
                                                <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow'>
                                                        <li>Relieving (Leave) Certificate from the Employer: <a className='c-link' href="https://files.iittp.ac.in/pdfs/admissions/2023/docx/relieving.docx" target="_blank;">Link</a></li>
                                                    </ul>
                                                </li>
                                            </ul>

                                        </li>
                                    </ul>


                                    <ul>
                                        <li>
                                            <b>  3. Internal (IIT Tirupati Staff): </b>

                                            <ul className='myulcustarrow'>
                                                <li> The applicant must be regular employee of IIT Tirupati.</li>
                                                <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                            </ul>
                                        </li>
                                    </ul>


                                    <ul>
                                        <li>
                                            <b> Note: </b>

                                            <ul className='myulcustarrow'>
                                                <li> (i) The minimum residential requirement for the M.S. research scholars under External/Part-time category of admission is one semester.</li>
                                                <li> (ii) Candidates admitted under Non-HTRA category cannot be moved to HTRA category at a later date.</li>
                                                <li> (iii) More details on External/Part-time category of admission, including any questions regarding the recognition of the organization/laboratory might be addressed to the Head of the department of interest or <Link to="mailto:admissions@iittp.ac.in">admissions@iittp.ac.in</Link> </li>
                                            </ul>
                                        </li>
                                    </ul>

                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Areas*/}

                        <div>
                            {areasOpen && <Fade in={areasOpen}>
                                <div>
                                    <h4 className='mb-4'>Research Areas</h4>
                                    <p>
                                    Applicants are required to select the research areas in the online admission portal as per the availability in the respective category/scheme. The available research areas for July 2024 admission notification are tabulated below. For interdisciplinary research, applicants are encouraged to browse research areas offered by various departments. Interested candidates with degree in Electrical / Electronics and Communications / Computer Science and Engineering are encouraged to apply for Robotics and Mechatronics listed under Mechanical Engineering.
                                        <b>SoP is mandatory for Chemical Engineering, Electrical Engineering and Mechanical Engineering : <a className='c-link' href="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf" target="_blank"> Click here for SoP template</a></b>
                                    </p>

                                    {/* Table */}
                                    <Table bordered responsive className="mt-3 c-table">
                                        <colgroup>
                                            <col style={{ width: '20%' }} /> {/* 33% for each column */}
                                            <col style={{ width: '40%' }} />
                                            <col style={{ width: '40%' }} />
                                        </colgroup>
                                        <tbody>
                                            {/* Table header */}
                                            <tr>
                                                <td><b>Department<img src="/result_htm_f6dcee4dfa07852d.png" width="14" height="14" hspace="54" vspace="15" /></b></td>
                                                <td><b>Division</b></td>
                                                <td ><b>Areas of Research</b></td>
                                            </tr>
                                            {/* Table rows */}
                                            {/* Row 1 */}
                                            <tr>
                                                <td>Chemical Engineering</td>
                                                <td >Chemical Engineering</td>
                                                <td >Nanobiotechnology, Process Control and Optimization, Machine Learning for Nanomaterials, Computer Vision for Process Engineering, Production and Distribution Optimization, Biomass to Chemicals/Fuel, Materials for Li-Ion and Na-Ion Batteries, Catalytic Conversion of Co2 to Fuel, Granular Flow, Theoretical Fluid Mechanics, Membrane Science, Food Science and Technology, Microfluidics, General Chemical Engineering, Molecular simulations for energy materials, Molecular simulations for soft matter and interfaces. </td>
                                            </tr>
                                            {/* Row 2 */}
                                                <tr>                                             
                                                <td rowspan="6" className='c-table-rowspan-align'>Civil and Environmental Engineering</td>
                                                    <td>Environmental Engineering</td>
                                                    <td>Environmental Engineering</td>
                                                </tr>
                                                <tr>
                                                    <td>Geoinformatics and Remote Sensing</td>
                                                    <td>Geoinformatics and Remote Sensing</td>
                                                </tr>

                                                <tr>
                                                    <td>Geotechnical Engineering</td>
                                                    <td>Geotechnical Engineering</td>
                                                </tr>

                                                <tr>
                                                    <td>Structural Engineering</td>
                                                    <td>Structural Engineering</td>
                                                </tr>

                                                <tr>
                                                    <td>Transportation Engineering</td>
                                                    <td>Transportation Engineering</td>
                                                </tr>
                                                <tr>
                                                    <td>Water Resources Engineering</td>
                                                    <td>Water Resources Engineering</td>
                                                </tr>
                                        
                                           
                                          
                                        
                                            {/* Row 3 */}
                                            <tr>
                                                <td rowSpan="3" >
                                                    Computer Science and
                                                    Engineering
                                                </td>
                                                <td>
                                                    Algorithm and Architecture
                                                </td>
                                                <td>
                                                Parallel Computing, High Performance Computing, Graph Analytics, Algorithms and Data Structures, Algorithms and Computational Complexity, Architecture and Processor Design, AI Accelerator/Hardware, VLSI Testing and Verification
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Learning Systems
                                                </td>
                                                <td>
                                                AI + Software Engineering, Software Systems, Computing for Education, Human-Computer Interaction, Reinforcement Learning, Data Science Algorithms and Applications,Adversarial Deep Learning, Federated Learning, Deep learning for Edge Devices, Deep Reinforcement Learning, Deep Learning, Stochastic Approximation Algorithms , Multi Agent Systems, Emergent Communication 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Intelligent Networks
                                                </td>
                                                <td>
                                                Computer Networks, Internet of Things, Machine Learning for IoTs, AI for Cybersecuirty
                                                </td>

                                            </tr>

                                            {/* Row 4 */}
                                            <tr>
                                                <td rowSpan="4" >
                                                    Electrical Engineering
                                                </td>

                                                <td>Power and Control</td>
                                                <td>
                                                Control and Robotics, Power Electronics, Smart Power Grids
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Signal Processing & Communications
                                                </td>
                                                <td>
                                                Computer Vision, Deep Learning and Medial Imaging, Next Generation Wireless Communication and Networks
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>Electronics</td>
                                                <td>Digital VLSI Design and Processor Architecture, Electronic Devices and Circuits, Electronic Instrumentation</td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    RF & Microwave
                                                </td>
                                                <td>
                                                Applied Electromagnetics, RF Sensors and Metamaterials, Antenna System Architecture
                                                </td>
                                            </tr>

                                           
                                            {/* Row 5 */}
                                            <tr>
                                                <td rowSpan="5" >
                                                    Mechanical Engineering
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    Advance Manufacturing
                                                </td>
                                                <td>
                                                Smart CNC Machine Tools, 4D Printing, Digital twin for metal additive manufacturing, Distortion control in ship buidling structures, Robotics in large-scale welding , Functionally graded materials manufacturing using twin wire arc additive manufacturing, Composite Filaments for 3D Printing, 3D Printing of Composite Structures, Advanced Manufacturing Processes
                                                </td>
                                            </tr>


                                            <tr>
                                                <td>Fluids and Thermal Engineering</td>
                                                <td>Fluid mechanics, Low speed aerodynamics, Wind tubrines,Drones, Energy storage ,Combustion, Heat transfer, High-speed combustion modelling, Hydrodynamics, Waves in Fluids, Non-Newtonian Fluid Flow, Computational Fluid Dynamics (CFD)</td>
                                            </tr>


                                            <tr>
                                                <td>
                                                    Robotics and Mechatronics
                                                </td>
                                                <td>
                                                Autonomous underwater Robot Design and Control, AI assisted concrete 3D printing, Optimization in robotics, Nonlinear estimation and control
                                                </td>
                                            </tr>


                                            <tr>
                                                <td>Solid Mechanics and Design</td>
                                                <td>Vehicle dynamics, Automotive NVH, Fault detection, Digital twin for health monitoring, Experimental and theoretical biomechanics, Physics informed machine learning, Computational Solid Mechanics, Machine Learning in Mechanics</td>
                                            </tr>
                                            {/* End of table rows */}
                                        </tbody>
                                    </Table>

                                    {/* <p><em>*These research areas available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</em></p> */}
                                </div>
                            </Fade>
                            }
                        </div>



                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && <Fade in={eligiblityOpen}>
                                <div>
                                    <h4 className='mb-4'>Eligibility</h4>
                                    <h5 className='mb-4'>Candidates seeking admission to the M.S. (R) program are required to meet the following minimum eligibility criteria:</h5>
                                    <ul className='myulcustarrow'>
                                        <li>
                                        Candidates with a Bachelor's degree in Engineering/Technology or a Master’s Degree (M.Sc / MCA etc.) in the relevant discipline with a valid GATE score.
                                        </li>
                                        <div className='text-center mb-2'> (or) </div>
                                        <li>
                                        Candidates with Associate membership and have passed both part A and part B of the examination of professional bodies such as The Institution of Engineers (India) (Civil/Mechanical/Electrical and Electronics/Electronics and communications), The Institute of Electronics and Tele-Communication Engineering with a good academic record and valid GATE score
                                        </li>
                                        <div className='text-center mb-2'> (or) </div>  
                                        <li>
                                        Candidates with a Bachelor’s degree in Engineering/Technology from any Indian Institute of Technology (IITs) with an exceptionally good academic record in an eligible discipline and a minimum CGPA of 8/10 (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                        </li>

                                    </ul>
                                    <span className='text-info'>Note: A valid GATE score is not required in the case of candidates applying under the external/part-time/internal category.  </span>


                                    <h5 className='mt-3 mb-3'>In addition, applicants under External/Part-Time/Internal category have to satisfy the following criteria:</h5>


                                    <h5 className='mt-3 mb-3'> External:</h5>

                                    <ul className='myulcustarrow'>
                                        <li>The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                        <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST or by IIT Tirupati.</li>
                                    </ul>

                                    <h5 className='mt-3 mb-3'>Part-Time:</h5>

                                    <ul className='myulcustarrow'>
                                        <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                        <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
                                    </ul>

                                    <h5 className='mt-3 mb-3'>Internal (IIT Tirupati Staff):</h5>
                                    <ul className='myulcustarrow'>
                                        <li> The applicant must be regular employees of IIT Tirupati.</li>
                                        <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                    </ul>
                                    
                                </div>

                            </Fade>
                            }
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                            {financialOpen && <Fade in={financialOpen}>
                                <div>
                                    <h4 className='mb-4'>Financial Assistance</h4>
                                    <p>
                                    Financial assistance will be provided as per Ministry of Education (MoE) norms. All full time regular scholars admitted to Ph.D. and M.S (Research) programs are eligible for the Half-time Research Assistantship (HTRA) for which:
                                    </p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                        They should work for 8 hours per week for the Institute to earn this assistantship. The work would normally involve assistance in teaching/research and will be assigned by the Institute.
                                        </li>
                                        <li>
                                        Renewal of assistantship every semester will be contingent on enrolment, satisfactory progress in research work and good performance during the preceding semester in the discharge of responsibility as teaching/ research assistant.
                                        </li>
                                        <li>
                                        Assistantship for candidates who have qualified through UGC-JRF, CSIR-JRF, ICMR & AICTE etc. will be as per the norms of the funding agency.
                                        </li>
                                    </ul>
                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Section*/}

                        <div>
                            {sectionOpen && <Fade in={sectionOpen}>
                                <div>
                                    <h4 className='mb-4'>Selection Procedure</h4>
                                    <p >The selection committee will call eligible candidates based on the minimum eligibility requirements and additional screening criteria for a written test (if any) and interview.</p>
                                </div>
                            </Fade>}
                        </div>


                        {/*Documents*/}

                        <div>
                            {documentsOpen && <Fade in={documentsOpen}>
                                <div>
                                    <h4 className='mb-4'>Original Documents to be submitted for Verification:</h4>
                                    <p>
                                        <b>At the time of Interview and/or Written Test:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of interview and/or written test.</p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                            Copy of application
                                        </li>
                                        <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                            Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                            Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                        </li>
                                        <li>
                                            Copy of valid GATE score (if applicable)
                                        </li>
                                        <li>
                                        Candidates applying under External Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/6.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        <li>
                                        Candidates applying under Part-Time Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/noc_parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        <li>
                                        Candidates applying under Internal Category must produce : No Objection Certificate
                                        </li>

                                    </ul>
                                    <p className='text-teal'>
                                    Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                    </p>
                                    <p>
                                        <b>At the time of Admission:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of admission / registration</p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                            Offer of admission.
                                        </li>
                                        <li>
                                            Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
                                        </li>
                                        <li>
                                            Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc.
                                        </li>
                                        <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                            Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                            Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                            Candidates admitted under External category must also produce:
                                            <ol className='ms-3'>
                                                <li>
                                                No Objection Certificate for using Research Facilities on the employer’s premises. <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/6.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                Consent of Co-supervisor from the parent organization in case of external candidates. <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/7.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/8.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>

                                            </ol>
                                        </li>

                                        Candidates admitted under Part-Time category must also produce: 
                                        <ol className='ms-3'>
                                            <li>
                                                Relieving order from the employer<Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/relieving.docx" target="_blank" className='c-link'>(Link)</Link>
                                            </li>
                                        </ol>
                                    </ul>

                                
                                    <p className='text-teal'>
                                    Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
                                    </p>
                                </div>
                            </Fade>}
                        </div>

                        {/*Section*/}

                        <div>
                            {feesOpen && <Fade in={feesOpen}>
                                <div>
                                    <h4 className='mb-4'>Fees and Deposits</h4>
                                    <p >The applicable tuition and other fee/ deposits for MS (Research) students is available at the following<Link to="/fee-structure" className='c-link'>link</Link>.</p>
                                </div>
                            </Fade>}
                        </div>
                        {/*Apply Online*/}

                        <div>
                            {applyonlineOpen && <Fade in={applyonlineOpen}>
                                <div>
                                    <h4 className='mb-4'>Apply Online</h4>
                                    <p><b>To Apply Online</b> : <Link to="#" className='c-link'><b>Online applications are now closed.</b></Link> </p>
                                     <p><b>To login and download application</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/msapplication.php" target="_blank" className='c-link'><b>Click Here</b></Link>
                                    </p>

                                        {/* <b>To Apply Online</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/msapplication.php" target="_blank" className='c-link'><b>Click Here</b></Link> */}

                                    

                                </div>
                            </Fade>}
                        </div>


                    </Col>

                </Row>
            </Container>
        </section>
    );
}

export default Ms_AdmissionELe;
